import type { StepOptionsButton } from 'shepherd.js';
import type { GuidedTourService } from '../guided-tour.service';
import { GuidedTourStep } from '../guided-tour.enum';

export type ShepherdButton = StepOptionsButton & {
  type?:
    | GuidedTourStep.Back
    | GuidedTourStep.Cancel
    | GuidedTourStep.Next
    | GuidedTourStep.Complete;
};

export function makeButton(this: GuidedTourService, button: ShepherdButton) {
  const { classes, disabled, label, secondary, type, text } = button;
  const builtInButtonTypes = [
    GuidedTourStep.Back,
    GuidedTourStep.Cancel,
    GuidedTourStep.Next,
    GuidedTourStep.Complete,
  ];

  if (!type) {
    return button;
  }

  if (builtInButtonTypes.indexOf(type) === -1) {
    throw new Error(
      `'type' property must be one of 'back', 'cancel', 'next', or  'complete''`,
    );
  }

  return {
    action: (this as GuidedTourService)[type]?.bind(this),
    classes,
    disabled,
    label,
    secondary,
    text,
  };
}
